import {
  CreateTaskRequest,
  Task,
  TaskNote,
  TaskPosition,
  TaskReflectionWithNote,
  TaskType,
  UpdateTaskRequest,
} from '@lyceo/shared/plan/util-models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const TaskActions = createActionGroup({
  source: 'Task API',
  events: {
    'Fetch Calendar Success': props<{ tasks: Task[] }>(),
    'Fetch Calendar Failure': props<{ error: Error }>(),

    'Prefetch Calendar Previous': emptyProps(),
    'Prefetch Calendar Previous Success': props<{ tasks: Task[] }>(),
    'Prefetch Calendar Previous Failure': props<{ error: Error }>(),

    'Prefetch Calendar Next': emptyProps(),
    'Prefetch Calendar Next Success': props<{ tasks: Task[] }>(),
    'Prefetch Calendar Next Failure': props<{ error: Error }>(),

    'Fetch By Date Success': props<{ tasks: Task[] }>(),
    'Fetch By Date Failure': props<{ error: Error }>(),

    'Create': props<{ request: CreateTaskRequest }>(),
    'Create Success': props<{ task: Task }>(),
    'Create Failure': props<{ error: Error }>(),

    'Update': props<{ request: UpdateTaskRequest }>(),
    'Update Success': props<{ task: Task }>(),
    'Update Failure': props<{ error: Error }>(),

    'Task Moved Success': props<{ tasks: TaskPosition[] }>(),
    'Task Moved Failure': props<{ error: Error }>(),

    'Update Pupil Done Success': props<{ task: Task }>(),
    'Update Pupil Done Failure': props<{ error: Error }>(),

    'Update Done At Success': props<{ task: Task }>(),
    'Update Done At Failure': props<{ error: Error }>(),

    'Delete': props<{ id: string }>(),
    'Delete Success': props<{ id: string }>(),
    'Delete Failure': props<{ error: Error }>(),

    'Get Success': props<{ task: Task }>(),
    'Get Failure': props<{ error: Error }>(),

    'Get Todo Tasks Success': props<{ tasks: Task[] }>(),
    'Get Todo Tasks Failure': props<{ error: Error }>(),
  },
});

export const TaskPageActions = createActionGroup({
  source: 'Task Page',
  events: {
    'Init': emptyProps(),
    'Todo Task Clicked': props<{ task: Task }>(),
  },
});

export const NewTaskModalActions = createActionGroup({
  source: 'New Task Modal',
  events: {
    'Task Type selected': props<{ taskType: TaskType }>(),
    'Closed': emptyProps(),
  },
});

export const TaskModalActions = createActionGroup({
  source: 'Task Modal',
  events: {
    'Init': emptyProps(),
    'Create Closed': emptyProps(),
    'Update Closed': emptyProps(),
  },
});

export const ReflectionModalActions = createActionGroup({
  source: 'Reflection Modal',
  events: {
    'Modal Closed': emptyProps(),
    'Update Reflection': props<{ request: TaskReflectionWithNote }>(),
    'Update Reflection Success': props<{ task: Task }>(),
    'Update Reflection Failure': props<{ error: Error }>(),
    'Upsert Note Success': props<{ note: TaskNote }>(),
    'Upsert Note Failure': props<{ error: Error }>(),
  },
});
